import React, { Component } from 'react';
import StatusComponent from './StatusComponent';
import FontFaceObserver  from 'fontfaceobserver';

import { getHeroTextBlock } from '../assets/shared/ThemeComponents.jsx';

class MainTextComponent extends Component {

    componentDidMount() {
        var font = new FontFaceObserver("Six Caps");
        font.load().then(this.handleLoad);
        window.addEventListener('resize', this.handleLoad, false);
    }

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.handleLoad, false);
    }

    handleLoad = () => {
        const helper = document.getElementById('title-helper');
        const title = document.getElementById('title');
        const subheadHelper = document.getElementById('subhead-helper');
        const subhead = document.getElementById('subhead');
        if (helper) {
            this.adjustSpacing(title, helper);
            this.adjustSpacing(subhead, subheadHelper);
        }
    }

    adjustSpacing = (element, helper) => {
        element.style.letterSpacing = 0;

        const helperWidth  = helper.clientWidth;
        const helperHeight = helper.clientHeight;
        const elementWidth   = element.clientWidth;
        const elementHeight  = element.clientHeight;

        const letters = element.textContent.length;
        const lines = Math.floor(elementHeight / helperHeight);
        const lettersPerLine = letters / lines;

        const letterWidth = helperWidth / letters;
        const letterSpacing = (elementWidth - helperWidth / lines) / lettersPerLine;

        let spacing = letterWidth > letterSpacing ? letterSpacing : letterWidth;

        element.style.letterSpacing = spacing * 0.75 + 'px';
    }

    render () {

        const { propertyInfo, theme, heroInfo } = this.props;

        return (
            <div className="main-text-component">
                <StatusComponent status={propertyInfo.listingStatus}/>
                {getHeroTextBlock(theme, propertyInfo, heroInfo)}
            </div>
        )
    }
}

export default MainTextComponent;
